import { useAppSelector } from '../app/hooks/store-hooks';

const useUserRights = () => {
    return useAppSelector((x) => x.user.rights);
};

/**
 * @deprecated Use useAppSelector(x => x.user.rights)
 */
export default useUserRights;
